enum WorkspaceProjectDatasetType {
  satellite = 'satellite',
  nft = 'nft',
  file = 'file',
  erc721 = 'erc721',
  carbonCredit = 'carbonCredit',
}

export default WorkspaceProjectDatasetType
